// app/javascript/controllers/checkbox_toggle_dropdown_controller.js
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["dropdownContainer", 'boardDropdownContainer', 'taskPositionDropdownContainer', 'generateMultiple', 'voiceTypeDropdownContainer']

  connect() {
    this.toggle() // Initial toggle on connect
  }

  toggle() {
      let selectedOption = this.dropdownContainerTarget.querySelector('select');
      this.toggleBoardDropDown({ target: selectedOption });
      selectedOption.addEventListener("change", this.toggleBoardDropDown.bind(this))
  }

  toggleBoardDropDown(){
    let selectedOption = this.dropdownContainerTarget.querySelector('select');

    if (selectedOption.value == 'create_project'){
      this.taskPositionDropdownContainerTarget.style.display = 'none'
      this.boardDropdownContainerTarget.style.display = 'block'
      this.voiceTypeDropdownContainerTarget.style.display = 'none'
    }else{
      this.boardDropdownContainerTarget.style.display = 'none'
    }
    
    if (selectedOption.value == 'create_task') {
      this.taskPositionDropdownContainerTarget.style.display = 'block'
      this.boardDropdownContainerTarget.style.display = 'none'
      this.voiceTypeDropdownContainerTarget.style.display = 'none'

    }else{
      this.taskPositionDropdownContainerTarget.style.display = 'none'
    }

    if (selectedOption.value == 'create_audio') {
      this.voiceTypeDropdownContainerTarget.style.display = 'block'
      this.boardDropdownContainerTarget.style.display = 'none'
      this.taskPositionDropdownContainerTarget.style.display = 'none'
    }else{
      this.voiceTypeDropdownContainerTarget.style.display = 'none'
    }
  }
}
